import React, { FC } from 'react';
import './NotificationsEmpty.scss';
import { useTranslation } from 'react-i18next';

export const NotificationsEmpty: FC = () => {
  const { t } = useTranslation();

  return <div className="NotificationsEmpty">{t('There are no such notifications')}</div>;
};
